import { useTranslation } from 'react-i18next'

import { Render } from '@/shared/components/render-if'
import { SimulacaoParcelasAgrupadas } from '@/shared/components/simulacao-agrupador-parcelas'
import { formatToBRL } from '@/shared/utils/currency.utils'

import { SectionItem, SectionItemValue } from './index'

type SectionItemParcelaProps<T extends { valor: number }> = {
  label: string
  parcela?: T
  colSpan?: 4 | 8 | 12
  withRightBorder?: boolean
  className?: string
}

export function SectionItemParcela<T extends { valor: number }>({
  label,
  parcela,
  colSpan,
  withRightBorder,
  className,
}: Readonly<SectionItemParcelaProps<T>>) {
  return (
    <SectionItem label={label} colSpan={colSpan} withRightBorder={withRightBorder} className={className}>
      <Render.If condition={parcela} fallback={<SectionItemValue>{formatToBRL(0)}</SectionItemValue>}>
        {(p) => <SectionItemValue>{formatToBRL(p.valor)}</SectionItemValue>}
      </Render.If>
    </SectionItem>
  )
}

type SectionItemGrupoParcelaProps<T extends Array<{ valor: number; quantidade: number }>> = {
  label: string
  parcelas?: T
  colSpan?: 4 | 8 | 12
  withRightBorder?: boolean
  className?: string
}

export function SectionItemGrupoParcela<T extends Array<{ valor: number; quantidade: number }>>({
  label,
  parcelas,
  colSpan,
  withRightBorder,
  className,
}: Readonly<SectionItemGrupoParcelaProps<T>>) {
  const { t } = useTranslation('simulacao')

  return (
    <SectionItem label={label} colSpan={colSpan} withRightBorder={withRightBorder} className={className}>
      <Render.If
        condition={parcelas}
        fallback={
          <SectionItemValue uppercase>{t('pages.simulacao.valores_simulados.nenhuma_parcela')}</SectionItemValue>
        }
      >
        {(p) => (
          <SimulacaoParcelasAgrupadas
            parcelas={p}
            isGrupoSaldo={false}
            className="font-poppins text-base font-normal"
          />
        )}
      </Render.If>
    </SectionItem>
  )
}
